import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { cn } from '@/lib/utils';

function highlightSearchMatch(text: string, searchTerm: string) {
  if (!text || !searchTerm) return text;
  const regex = new RegExp(`(${searchTerm})`, 'gi');
  return text.split(regex).map((part) => (regex.test(part) ? <b>{part}</b> : part));
}

export const UserAvatarLabel = ({
  value,
  operatedByFullInitials,
  avatarUrl,
  avatarBackgroundColorClass,
  searchTerm,
  avatarSize = 'sm',
}: {
  value: string;
  operatedByFullInitials: string;
  avatarUrl: string;
  avatarBackgroundColorClass: string;
  searchTerm?: string;
  avatarSize?: 'sm' | 'md' | 'lg';
}) => {
  const avatarSizeClass = cn('size-[28px]', avatarSize === 'sm' && 'size-[21px]', avatarSize === 'md' && 'size-[24px]');
  const textFontSizeClass = cn('font-[700]', avatarSize === 'sm' && 'font-[400]', avatarSize === 'md' && 'font-[500]');
  return (
    <div className="flex items-center gap-2">
      {value !== '-' && (
        <Avatar className={avatarSizeClass}>
          {avatarUrl ? (
            <img className="h-full w-full rounded-full object-cover" src={avatarUrl} />
          ) : (
            operatedByFullInitials.length && (
              <AvatarFallback className={cn('text-xs', textFontSizeClass, avatarBackgroundColorClass)}>{operatedByFullInitials}</AvatarFallback>
            )
          )}
        </Avatar>
      )}
      <span className={cn('overflow-hidden text-sm overflow-ellipsis', value === '-' && 'text-secondary-text')}>
        {searchTerm ? highlightSearchMatch(value, searchTerm) : value}
      </span>
    </div>
  );
};
